import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import store from '../redux/store';
var handshake = {};
document.addEventListener('keydown', function (event) {
  if (event.code === 'Escape') {
    var message = {
      topic: "scene_manager",
      message: {
        api: "restart_scene"
      }
    };
    SendUnityMessage(message);
  }
});

var Drive = function Drive() {
  SendUnityMessage({
    "topic": "basic_movement",
    "message": {
      api: "drive"
    }
  });
};

var DriveStop = function DriveStop() {
  SendUnityMessage({
    "topic": "basic_movement",
    "message": {
      api: "stop_drive"
    }
  });
};

var ShootTorpedo = function ShootTorpedo() {
  SendUnityMessage({
    "topic": "game",
    "message": {
      api: "fire"
    }
  });
};

var sleep = function sleep(m) {
  return new Promise(function (r) {
    return setTimeout(r, m);
  });
};

var Turn = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(units) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return UnityPromise({
              "topic": "basic_movement",
              "message": {
                "api": "turn",
                "param": {
                  "value": units
                }
              }
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function Turn(_x) {
    return _ref.apply(this, arguments);
  };
}();

var TouchSensor = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(state) {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return UnityPromise({
              "topic": "sensing",
              "message": {
                "api": "sensor_get_touch"
              }
            }).then(function (response) {
              result = response.message.value === parseInt(state) ? true : false;
            });

          case 2:
            return _context2.abrupt("return", result);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function TouchSensor(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var WaitForSeconds = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return sleep(value * 1000);

          case 2:
            return _context3.abrupt("return", true);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function WaitForSeconds(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var UnityPromise = function UnityPromise(msg) {
  return new Promise(function (resolve, reject) {
    handshake = {
      resolve: resolve,
      reject: reject
    };
    SendUnityMessage(msg);
  });
};

var SendUnityMessage = function SendUnityMessage(msg) {
  var _store$getState = store.getState(),
      unity = _store$getState.unity;

  var message = JSON.stringify(msg);
  unity.content.send("UnityComms", "OnMessageToUnity", message);
};

var EvalCode = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(code) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return eval("(async () => {" + code + "})()");

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function EvalCode(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

export { handshake, EvalCode, Drive, DriveStop, ShootTorpedo, TouchSensor, Turn, WaitForSeconds };